document.addEventListener("DOMContentLoaded", function () {
  // Helper: Smooth scroll to element by id, always taking the same duration
  function scrollToSection(id, duration = 900) {
    const target = document.getElementById(id);
    if (!target) return;

    const targetY = target.getBoundingClientRect().top + window.pageYOffset;
    const startY = window.pageYOffset;
    const diff = targetY - startY;
    const startTime = performance.now();

    function animateScroll(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + diff * easeInOutQuad(progress));
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }
    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    requestAnimationFrame(animateScroll);
  }

  // Select all .subnav and footer .link-group links
  document.querySelectorAll('.subnav a, footer .links .link-group a').forEach(link => {
    link.addEventListener('click', function (e) {
      // Parse the link's href
      const href = this.getAttribute('href');
      if (!href) return;

      // Support both #anchor and /page#anchor and full URLs
      let hash = null;
      if (href.startsWith('#')) {
        hash = href;
      } else {
        const url = new URL(href, window.location.origin);
        // Only handle if the link is for the current page
        if (url.pathname === window.location.pathname && url.hash) {
          hash = url.hash;
        }
      }

      if (hash && hash.length > 1) {
        const id = hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          scrollToSection(id);
        }
      }
    });
  });

  // If page loads with an anchor in the URL, scroll to it after DOM is ready
  function scrollToHashIfPresent() {
    if (window.location.hash && document.getElementById(window.location.hash.slice(1))) {
      // Use setTimeout to ensure layout is ready and browser hasn't already jumped
      setTimeout(() => {
        scrollToSection(window.location.hash.slice(1));
      }, 100);
    }
  }

  // Prevent browser's default jump to anchor on load, then smooth scroll
  if (window.location.hash) {
    // Scroll to top instantly so browser doesn't jump to anchor
    window.scrollTo(0, 0);
    // Then smooth scroll to anchor after DOM is ready
    scrollToHashIfPresent();
  }

  // Also handle hash changes after initial load (user types in anchor or uses history)
  window.addEventListener('hashchange', scrollToHashIfPresent);
});